<template>
  <div class="zonesIntention"></div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { generateColors } from '@/utils/colors.util'

export default {
  name: 'ZonesIntention',
  props: {
    map: {
      type: Object,
      required: true,
    },
    zones: {
      type: Array,
      required: true,
    },
    filters: {
      type: Array,
      required: true,
    },
  },
  watch: {
    zones: {
      deep: true,
      handler() {
        this.resetGeoJson()
        this.setCurrentZone(null)
        this.addGeoJson()
      },
    },
    mapBounds() {
      const bounds = this.map.getBounds()
      const mapCenter = this.map.getCenter()
      const mapLatLng = `${mapCenter.lat()},${mapCenter.lng()}`
      const northEst = bounds.getNorthEast()
      // eslint-disable-next-line no-undef
      const mapRadius = Math.round(google.maps.geometry.spherical.computeDistanceBetween(mapCenter, northEst))
      this.setCurrentMapCenter(mapLatLng)
      this.setCurrentMapRadius(mapRadius)
    },
  },
  mounted() {
    this.addGeoJson()
    this.map.setOptions({ minZoom: 0 })
  },
  computed: {
    ...mapState({
      geoJsons: state => state.data.geoJsons,
      brandSettings: state => state.data.settings,
      locations: state => state.data.locations,

      mapBounds: state => state.radar.map.bounds,

      currentKpi: state => state.refine.currentKpi,
    }),
  },
  methods: {
    ...mapActions({
      getClientGeoJsons: 'data/getClientGeoJsons',
      setCurrentZone: 'data/setCurrentZone',

      toggleRefreshZones: 'radar/toggleRefreshZones',
      setCurrentMapCenter: 'radar/setCurrentMapCenter',
      setCurrentMapRadius: 'radar/setCurrentMapRadius',
    }),
    async getJsons() {
      this.toggleRefreshZones(true)
      await this.getClientGeoJsons(this.zones).then(() => {
        this.toggleRefreshZones(false)
        return true
      })
    },
    async addGeoJson() {
      await this.getJsons()

      this.geoJsons.forEach(geojson => {
        try {
          this.map.data.addGeoJson(geojson)
        } catch (e) {
          console.error(`The following geosjon is invalid: ${geojson.features[0].properties.name}\n${e}`)
        }
      })
      this.setGeoJsonColors()
      this.setEventListener()
    },
    setGeoJsonColors() {
      this.map.data.setStyle(feature => {
        try {
          const key = feature.getProperty('value')
          const zone = this.zones.filter(zone => zone.key === key)[0]
          return {
            fillColor: generateColors(zone.value, this.filters) || 'transparent',
            strokeWeight: 0.5,
            fillOpacity: 0.8,
          }
        } catch (e) {
          return {
            fillColor: 'transparent',
            strokeWeight: 0,
            fillOpacity: 0,
          }
        }
      })
    },
    resetGeoJson() {
      this.map.data.forEach(feature => {
        this.map.data.remove(feature)
      })
    },
    setEventListener() {
      // eslint-disable-next-line no-undef
      google.maps.event.clearInstanceListeners(this.map.data)
      if (this.$route.name === 'zonesIntention') {
        this.map.data.addListener('click', e => {
          const key = e.feature.getProperty('value')
          this.$router.push({ name: 'divisionZonesIntention', params: { level: 1, key }, query: { level: 2 } })
        })
        this.map.data.addListener('mouseover', e => {
          const key = e.feature.getProperty('value')
          const zone = this.zones.filter(zone => zone.key === key)[0]
          this.setCurrentZone(zone)
        })
        this.map.data.addListener('mouseout', () => {
          this.setCurrentZone(null)
        })
      } else {
        this.map.data.addListener('click', e => {
          const key = e.feature.getProperty('value')
          const zone = this.zones.filter(zone => zone.key === key)[0]
          this.setCurrentZone(zone)
        })
      }
    },
  },
  beforeDestroy() {
    this.setCurrentZone(null)
    this.resetGeoJson()
  },
}
</script>
